var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72282 8.00016C4.72282 6.9263 3.85228 6.05574 2.7784 6.05574C1.70453 6.05574 0.833984 6.9263 0.833984 8.00016C0.833984 9.07402 1.70453 9.94458 2.7784 9.94458C3.85228 9.94458 4.72282 9.07402 4.72282 8.00016Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6115 12.2778L4.72266 9.55564",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6115 3.72239L4.72266 6.44458",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 2.9445C12.5002 1.87063 11.6296 1.00008 10.5557 1.00008C9.48188 1.00008 8.61133 1.87063 8.61133 2.9445C8.61133 4.01836 9.48188 4.88892 10.5557 4.88892C11.6296 4.88892 12.5002 4.01836 12.5002 2.9445Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 13.0556C12.5002 11.9817 11.6296 11.1112 10.5557 11.1112C9.48188 11.1112 8.61133 11.9817 8.61133 13.0556C8.61133 14.1295 9.48188 15 10.5557 15C11.6296 15 12.5002 14.1295 12.5002 13.0556Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareicon);
export default __webpack_public_path__ + "static/media/shareicon.f363f155af98f6367c15b1eb4b18caa8.svg";
export { ForwardRef as ReactComponent };